<template>
    <router-view></router-view> <!-- 路由匹配的组件会渲染在这里 -->
</template>

<style>
* {
  margin: 0;
}

.title {
  height: 55px;
  box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.5);
  /* border-bottom: 1px solid #000; */
  text-align: center;
  line-height: 55px;
}
.download-map {
  display: flex;
  justify-content: space-between;
  width: 1250px;
  margin: 24px auto 0;
}
.download-title {
  position: relative;
  margin-left: 10px;
  line-height: 32px;
}

.download-title::before {
  content: "";
  width: 3px;
  height: 20px;
  background-color: #3b7eff;
  position: absolute;
  left: -10px;
  top: 50%;
  margin-top: -9px;
}
.change-language {
  width: 100px;
}
</style>
